export default __webpack_public_path__ + "static/1-0e5821037daa8e07c068b5349e96a85d.jpg";